module.exports = __webpack_public_path__ + "static/media/ploni-ultralight-aaa.e245c20c.eot";